<div class="row px-0" *ngFor="let row of newRows">
  <app-zone-container
    [zoneItems]="row?.zones"
    style="width: 100%"
  ></app-zone-container>
</div>
